module.exports = __webpack_public_path__ + "img/icon03.081fede.png";